import { useEffect, useState } from "react";

const STORAGE_KEY = "gd-theme";

export default function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const initialTheme = saved || (systemDark ? "dark" : "light");
    setTheme(initialTheme);
    document.documentElement.classList.toggle("dark", initialTheme === "dark");
  }, []);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    localStorage.setItem(STORAGE_KEY, next);
    document.documentElement.classList.toggle("dark", next === "dark");
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`inline-flex h-10 w-10 items-center justify-center rounded-xl border border-[#d3e2f6] bg-white text-[#0f3d7a] shadow-sm transition hover:-translate-y-0.5 dark:border-[#2b3f5c] dark:bg-[#17263a] dark:text-[#c9dcf8] ${className}`}
      aria-label="თემის შეცვლა"
      title="თემის შეცვლა"
    >
      {theme === "dark" ? "☀️" : "🌙"}
    </button>
  );
}
